import useAdsView from "./useAdsView";

export const AdsViewInitializer = () => {
	useAdsView();

	return null;
};
